import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../constants';

const API_URL = API_BASE_URL;

// Módulos del menú lateral. Un item con children es desplegable: al tocarlo
// abre su primera opción y muestra las demás debajo.
const menuItems = [
  { id: 'liquidacion', label: 'Liquidación', icon: 'liquidacion' },
  {
    id: 'costos-cloud',
    label: 'Costos Cloud',
    icon: 'consumo',
    children: [
      { id: 'costos-cloud', label: 'Consumo mensual' },
      { id: 'distribucion', label: 'Distribución servicios' }
    ]
  },
  { id: 'costos-proveedor', label: 'Costos Proveedor', icon: 'proveedor' },
  { id: 'tbbc', label: 'TBBC', icon: 'tbbc' },
  { id: 'optimize', label: 'Optimize', icon: 'optimize' },
  { id: 'axd', label: 'AXD', icon: 'axd' },
  { id: 'areas', label: 'Áreas', icon: 'areas' },
  { id: 'compartir', label: 'Compartir', icon: 'compartir' },
  // { id: 'proceso', label: 'Cloud', icon: 'dashboard' }, // oculto: lo reemplazó Costos Cloud
];

const icons = {
  dashboard: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  tbbc: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  optimize: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <line x1="1" y1="14" x2="7" y2="14" />
      <line x1="9" y1="8" x2="15" y2="8" />
      <line x1="17" y1="16" x2="23" y2="16" />
    </svg>
  ),
  axd: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </svg>
  ),
  consumo: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="17" x2="8" y2="14" />
      <line x1="12" y1="17" x2="12" y2="12" />
      <line x1="16" y1="17" x2="16" y2="15" />
    </svg>
  ),
  liquidacion: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="8" y1="13" x2="16" y2="13" />
      <line x1="8" y1="17" x2="13" y2="17" />
    </svg>
  ),
  proveedor: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
      <line x1="2" y1="13" x2="22" y2="13" />
    </svg>
  ),
  compartir: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <line x1="8.6" y1="13.5" x2="15.4" y2="17.5" />
      <line x1="15.4" y1="6.5" x2="8.6" y2="10.5" />
    </svg>
  ),
  areas: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="7" height="16" rx="1" />
      <rect x="14" y="4" width="7" height="16" rx="1" />
      <line x1="5.5" y1="8" x2="7.5" y2="8" />
      <line x1="16.5" y1="8" x2="18.5" y2="8" />
    </svg>
  ),
};

export const Sidebar = ({ activeModule, onModuleChange, isCollapsed, onToggleCollapse }) => {
  const [uploadStatus, setUploadStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');
  const [desplegados, setDesplegados] = useState({});

  const handlePaste = async (e) => {
    e.preventDefault();
    const items = e.clipboardData?.items;

    if (!items) return;

    for (const item of items) {
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        if (file) {
          await uploadImage(file);
          return;
        }
      }
    }

    setUploadStatus('error');
    setStatusMessage('No hay imagen en el portapapeles');
    setTimeout(() => setUploadStatus(null), 3000);
  };

  const uploadImage = async (file) => {
    setUploadStatus('uploading');
    setStatusMessage('Subiendo...');

    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await axios.post(`${API_URL}/upload-image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.data.success) {
        setUploadStatus('success');
        setStatusMessage('Imagen guardada');
        setTimeout(() => setUploadStatus(null), 3000);
      }
    } catch (error) {
      console.error('Error subiendo imagen:', error);
      setUploadStatus('error');
      setStatusMessage('Error al guardar');
      setTimeout(() => setUploadStatus(null), 3000);
    }
  };

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-toggle" onClick={onToggleCollapse}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          {isCollapsed ? (
            <path d="M9 18l6-6-6-6" />
          ) : (
            <path d="M15 18l-6-6 6-6" />
          )}
        </svg>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const hijos = item.children || [];
          const dentro = hijos.some((h) => h.id === activeModule);
          const abierto = hijos.length > 0 && (dentro || desplegados[item.id]);
          return (
            <React.Fragment key={item.id}>
              <button
                className={`sidebar-item ${activeModule === item.id || dentro ? 'active' : ''} ${hijos.length ? 'has-children' : ''}`}
                onClick={() => {
                  if (hijos.length && dentro) {
                    setDesplegados((d) => ({ ...d, [item.id]: !abierto }));
                    return;
                  }
                  onModuleChange(hijos.length ? hijos[0].id : item.id);
                }}
                title={isCollapsed ? item.label : ''}
                aria-expanded={hijos.length ? Boolean(abierto) : undefined}
              >
                <span className="sidebar-icon">{icons[item.icon]}</span>
                {!isCollapsed && <span className="sidebar-label">{item.label}</span>}
                {!isCollapsed && hijos.length > 0 && (
                  <span className={`sidebar-chevron ${abierto ? 'open' : ''}`}>›</span>
                )}
              </button>
              {!isCollapsed && abierto && (
                <div className="sidebar-sub">
                  {hijos.map((h) => (
                    <button
                      key={h.id}
                      className={`sidebar-subitem ${activeModule === h.id ? 'active' : ''}`}
                      onClick={() => onModuleChange(h.id)}
                    >
                      {h.label}
                    </button>
                  ))}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </nav>

      {/* Pegado de imágenes: utilidad de desarrollo, a propósito casi invisible */}
      <div className="sidebar-footer">
        <div
          className={`clipboard-paste-icon ${uploadStatus || ''}`}
          onPaste={handlePaste}
          tabIndex={0}
          title={statusMessage || 'Pegar imagen (Ctrl+V) · pruebas de desarrollo'}
          aria-label="Pegar imagen"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        </div>
      </div>
    </aside>
  );
};
